import { EventEmitter } from 'events'
import { Job, JobWizard } from 'sprockets_react/job_wizards/registries'

Job.Store = new EventEmitter();

var jobStore = Job.Store
var CHANGE_EVENT = 'change'

jobStore.getCategory = function() {
    return {
        category:           Job.Data.category,
        category_id:        Job.Data.category_id,
        keyword:            Job.Data.keyword
    }
}

jobStore.getSuburb = function() {
    return { suburb: Job.Data.suburb, suburb_id: Job.Data.suburb_id }
}

jobStore.getExtraDetailsValue = function(key) {
    return Job.Data.extraDetails[key]
}

jobStore.addChangeListener = function(callback) {
    this.on(CHANGE_EVENT, callback)
}

jobStore.removeChangeListener = function(callback) {
    this.removeListener(CHANGE_EVENT, callback)
}

Job.Store.dispatchToken = Job.Dispatcher.register(function(payload) {

    var job = Job.Data; // JobWizard.Store.get();

    switch (payload.type) {
      case 'job:data:reset':
          Job.Data = Job.seedData()
          if (typeof SS !== 'undefined') {
              SS.phoneVerificationRequired = false
          }
              // Job.Store.emit(CHANGE_EVENT);
          break;
      case 'job:data:location_changed':
          job.suburb_id = payload.value.id
          job.suburb = payload.value.value
          job.phoneVerificationRequired = false
          if (typeof SS !== 'undefined') {
              SS.phoneVerificationRequired = false
          }
          break;
      case 'job:data:phone_verification_required_update':
          if (Number(job.suburb_id) !== Number(payload.suburbId)) {
              break;
          }

          job.phoneVerificationRequired = payload.value
          if (typeof SS !== 'undefined') {
              SS.phoneVerificationRequired = payload.value
          }
          break;
      case 'job:data:category_changed':
          job.category = payload.value.value
          job.category_id = payload.value.id
          break;
      case 'job:data:categories_reset':
          job.categories = []
          break;
      case 'job:data:description_changed':
          job.description = payload.value;
          break;
      case 'job:data:file_uploaded':
          job.attachments.push(payload.value)
          break;
      case 'job:data:budgetinmind_changed':
          job.budgetInMind = payload.value;
          if (payload.value === "no") {
              job.budgetPriceRange = null
              job.budgetType = null
              job.budgetSetPriceRange = null
          }
          break;
      case 'job:data:budgetsetpricerange_changed':
          var payloadValue = payload.value.replace(/\$|_/g, '');
          job.budgetSetPriceRange = payloadValue;
          job.minBudget = payloadValue;
          job.maxBudget = payloadValue;
          break;
      case 'job:data:budgettype_changed':
          job.budgetType = payload.value;

          if (job.budgetType === "set_price") {
              job.budgetPriceRange = null
          } else {
              job.budgetSetPriceRange = null
          }

          break;
      case 'job:data:budgetpricerange_changed':
          job.budgetPriceRange = payload.value;
          job.minBudget = payload.value.minimumBudget;
          job.maxBudget = payload.value.maximumBudget;
          break;
      case 'job:data:sitevisit_changed':
          job.siteVisit = payload.value;
          job.siteVisitTime = null;
          break;
      case 'job:data:sitevisittime_changed':
          job.siteVisitTime = payload.value;
          break;
      case 'job:data:quotetype_changed':
          job.quoteType = payload.value;
          break;
      case 'job:data:subcategory_added':
          job.categories.push(payload.value)
          if (job.category_id == 0) {
              job.category = payload.value.value
              job.category_id = payload.value.id;
          }
          break;
      case 'job:data:subcategory_removed':
        var tmpCategories = []

          job.categories.forEach(function(el) {
              if (el.id !== payload.value.id) {
                  var subcategory = payload.subcategoryType === 'additional' ? el : payload.value

                  tmpCategories.push(el)
              }
          })

          if (job.category_id == payload.value.id) {
              var category_id = (tmpCategories[0] === undefined) ? 0 : tmpCategories[0].id;
              var category = (tmpCategories[0] === undefined) ? "" : tmpCategories[0].value;
              job.category_id = category_id;
              job.category = category;
          }

          job.categories = tmpCategories
          break;
      case 'job:data:subcategoryother_changed':
          job.categoryOther = payload.value;
          break;
      case 'job:data:keyword_changed':
          job.keyword = payload.value;
          break;
      case 'job:data:contactoptions_update':
          job.canCall = payload.value
          break;
      case 'job:data:schedule_changed':
          job.schedule = payload.value

          if (payload.value !== "on_a_particular_date") {
              job.scheduleDate = ""
          }
          break;
      case 'job:data:scheduledate_changed':
          job.scheduleDate = payload.value
          break;
      case 'job:data:email_changed':
          job.emailAddress = payload.value.replace(/[\s]/g, '')
          break;
      case 'job:data:extra_details_add':
          var key = Object.keys(payload.value)[0]
          job.extraDetails[key] = payload.value[key]
          break;
      case 'job:data:extra_details_remove':
          var existingItemIndex = job.extraDetails.indexOf(payload.value)
          if(existingItemIndex > -1) {
              job.extraDetails.splice(existingItemIndex, 1)
          }
          break;
      case 'job:data:urgent_product_add':
          job.products.urgent = payload.value
          break;
      case 'job:data:workmanship_product_add':
          job.products.workmanship = payload.value
          break;
      case 'job:data:originname_changed':
          job.originName = payload.value
          break;
      case 'job:data:contact_preference_changed':
          job.contactPreference = payload.value
          break;
      case 'job:data:quote_estimate_changed':
          job.quoteEstimate = payload.value
          break;
      case 'job:data:phone_number_update':
          job.phoneNumber = payload.value
          break;
      case 'job:data:phone_number_edit_requested_update':
          job.phoneNumberEditRequested = payload.value
          break;
      case 'job:data:omni_auth_details_update':
          for (var key in payload.value){
            job.omniAuthDetails[key] = payload.value[key]
          }
          break;
      case 'job:data:omni_auth_details_reset':
          job.omniAuthDetails = {}
          break;
      case 'job:data:must_create_account_update':
          job.mustCreateAccount = payload.value
          break;
      case 'job:data:first_name_update':
          job.firstName = payload.value
          break;
      case 'job:data:back_to_submit_update':
          job.backToSubmit = payload.value
          break;
      case 'job:data:file_names_update':
          if (job.fileNames.indexOf(payload.value) < 0) {
              job.fileNames.push(payload.value)
          }
          break;
      case 'job:data:omni_auth_provider_update':
          job.omniAuthProvider = payload.value
          break;
      case 'job:data:last_slide_update':
        job.lastSlide = payload.value
        break;
      case 'job:data:budgetsetpricerange_changed':
          var payloadValue = payload.value.replace(/\$|_/g, '');
          job.budgetSetPriceRange = payloadValue;
          job.minBudget = payloadValue;
          job.maxBudget = payloadValue;
          break;
      case 'job:data:budgettype_changed':
          job.budgetType = payload.value;

          if (job.budgetType === "set_price") {
              job.budgetPriceRange = null
          } else {
              job.budgetSetPriceRange = null
          }

          break;
      case 'job:data:budgetpricerange_changed':
          job.budgetPriceRange = payload.value;
          job.minBudget = payload.value.minimumBudget;
          job.maxBudget = payload.value.maximumBudget;
          break;
      case 'job:data:sitevisit_changed':
          job.siteVisit = payload.value;
          job.siteVisitTime = null;
          break;
      case 'job:data:sitevisittime_changed':
          job.siteVisitTime = payload.value;
          break;
      case 'job:data:quotetype_changed':
          job.quoteType = payload.value;
          break;
      case 'job:data:subcategory_added':
          job.categories.push(payload.value)
          if (job.category_id == 0) {
              job.category = payload.value.value
              job.category_id = payload.value.id;
          }
          break;
      case 'job:data:subcategory_removed':
          var tmpCategories = []

          job.categories.forEach(function(el) {
              if (el.id !== payload.value.id) {
                  var subcategory = payload.subcategoryType === 'additional' ? el : payload.value

                  tmpCategories.push(el)
              }
          })

          if (job.category_id == payload.value.id) {
              var category_id = (tmpCategories[0] === undefined) ? 0 : tmpCategories[0].id;
              var category = (tmpCategories[0] === undefined) ? "" : tmpCategories[0].value;
              job.category_id = category_id;
              job.category = category;
          }

          job.categories = tmpCategories
          break;
      case 'job:data:subcategoryother_changed':
          job.categoryOther = payload.value;
          break;
      case 'job:data:keyword_changed':
          job.keyword = payload.value;
          break;
      case 'job:data:contactoptions_update':
          job.canCall = payload.value
          break;
      case 'job:data:schedule_changed':
          job.schedule = payload.value

          if (payload.value !== "on_a_particular_date") {
              job.scheduleDate = ""
          }
          break;
      case 'job:data:scheduledate_changed':
          job.scheduleDate = payload.value
          break;
      case 'job:data:email_changed':
          job.emailAddress = payload.value.replace(/[\s]/g, '')
          break;
      case 'job:data:extra_details_add':
          var key = Object.keys(payload.value)[0]
          job.extraDetails[key] = payload.value[key]
          break;
      case 'job:data:extra_details_remove':
          var existingItemIndex = job.extraDetails.indexOf(payload.value)
          if(existingItemIndex > -1) {
              job.extraDetails.splice(existingItemIndex, 1)
          }
          break;
      case 'job:data:urgent_product_add':
          job.products.urgent = payload.value
          break;
      case 'job:data:workmanship_product_add':
          job.products.workmanship = payload.value
          break;
      case 'job:data:originname_changed':
          job.originName = payload.value
          break;
      case 'job:data:contact_preference_changed':
          job.contactPreference = payload.value
          break;
      case 'job:data:quote_estimate_changed':
          job.quoteEstimate = payload.value
          break;
      case 'job:data:phone_number_update':
          job.phoneNumber = payload.value
          break;
      case 'job:data:phone_number_edit_requested_update':
          job.phoneNumberEditRequested = payload.value
          break;
      case 'job:data:omni_auth_details_update':
          for (var key in payload.value){
            job.omniAuthDetails[key] = payload.value[key]
          }
          break;
      case 'job:data:omni_auth_details_reset':
          job.omniAuthDetails = {}
          break;
      case 'job:data:must_create_account_update':
          job.mustCreateAccount = payload.value
          break;
      case 'job:data:first_name_update':
          job.firstName = payload.value
          break;
      case 'job:data:back_to_submit_update':
          job.backToSubmit = payload.value
          break;
      case 'job:data:file_names_update':
          if (job.fileNames.indexOf(payload.value) < 0) {
              job.fileNames.push(payload.value)
          }
          break;
      case 'job:data:omni_auth_provider_update':
          job.omniAuthProvider = payload.value
          break;
      case 'job:data:from_price_calculator':
          job.fromPriceCalculator = payload.value
          break;
      case 'job:data:additional_question_update':
          job.additionalQuestion = payload.value
          break;
      case 'job:data:otp_update':
          job.otp = payload.value
          break;
      case 'job:data:closure_survey_update': 
        job.closureSurvey = payload.value
        break;
      case 'job:data:progress_width_update':
          job.progressWidth = payload.value
          break;
      case 'job:data:chose_more_details_update':
          job.choseMoreDetails = payload.value
          break;
      case 'job:data:preferred_outcome_update':
          job.preferredOutcome = payload.value
          break;
      case 'job:data:reset_email_address_slide':
          job.resetEmailAddressSlide = payload.value
          break;
    }

    Job.Store.emit('change');
})
